module.exports = __webpack_public_path__ + "img/heading-point.105de1c6.svg";